
import { useCardData } from '@/hooks/admin/cards/useCardData';
import { useCardDialog } from '@/hooks/admin/cards/useCardDialog';
import { useCardOperations } from '@/hooks/admin/cards/useCardOperations';
import { CardItem } from './CardForm';

export const useCardManagement = () => {
  // Compose smaller hooks
  const { cards, setCards, isLoading } = useCardData();
  const { 
    dialogOpen, 
    setDialogOpen, 
    currentCard, 
    setCurrentCard, 
    isEditing, 
    handleOpenDialog 
  } = useCardDialog();
  
  const { saveCard, deleteCard, isProcessing } = useCardOperations({
    cards,
    setCards,
    setDialogOpen
  });

  // Create a wrapped save handler that uses the current card state
  const handleSaveCard = () => {
    return saveCard(currentCard, isEditing);
  };

  const handleDeleteCard = (cardId: string) => {
    return deleteCard(cardId);
  };

  return {
    cards,
    isLoading,
    dialogOpen,
    setDialogOpen,
    currentCard,
    setCurrentCard,
    isEditing,
    handleOpenDialog,
    handleSaveCard,
    handleDeleteCard,
    isProcessing
  };
};
